interface IQueryAPI<T extends (...arg: any) => any> {
  method?: string;
  url: string;
  variables?: Record<string, Parameters<T>[0]> | Parameters<T>[0];
  headers?: HeadersInit;
  options?: any;
}
export async function queryApi<T extends (...args: any) => any>({
  method = 'POST',
  url,
  variables,
  headers,
  options,
}: IQueryAPI<T>): Promise<Response> {
  const res = await fetch(url, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    body: variables ? JSON.stringify(variables) : undefined,
    ...options,
  });
  if (res.status >= 400) {
    throw new Error(await res.text());
  }
  return res;
}
